import { render } from "./SettingsForm.vue?vue&type=template&id=421282ef&scoped=true"
import script from "./SettingsForm.vue?vue&type=script&lang=js"
export * from "./SettingsForm.vue?vue&type=script&lang=js"

import "./SettingsForm.vue?vue&type=style&index=0&id=421282ef&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-421282ef"]])

export default __exports__